import React from 'react'

import clsx from 'clsx'

import EmptyState from 'components/EmptyState'
import Icon from 'components/Icon'
import Currency from 'components/Pricing/components/Currency'
import Tag from 'components/Tag'
import Typography from 'components/Typography'
import { mapPricingCategories, getPricingTexts } from 'helpers/dataTransformers/pricing'
import { priceFormatter } from 'helpers/formatters'

import icPricetagSVG from 'assets/ic-pricetag.svg'

import classes from './PricingDetails.module.scss'

/** @type {import("./types").default} */
const PricingDetails = ({ pricing, align = 'right', className }) => {
  const { periodicityText, pricingModelText } = getPricingTexts(pricing)
  const { hasFreeTrial, isFree } = mapPricingCategories(pricing?.categories)

  const hasAmount = !!pricing?.amount
  const hasPrice = Number(pricing?.amount) > 0

  return (
    <div className={clsx(classes.root, { [classes[align]]: align }, className)}>
      {!hasAmount ? (
        <EmptyState img={icPricetagSVG.src} text="No pricing info" variant="small" />
      ) : (
        <>
          {hasPrice && (
            <>
              <div className={classes.amount}>
                <Currency pricing={pricing} />
                <Typography component="span" className={classes.number}>
                  {priceFormatter(pricing?.amount)}
                </Typography>
              </div>
              <div className={classes.details}>
                <Typography variant="tight-xxs" component="span">
                  {pricingModelText}
                </Typography>
                {periodicityText ? '/' : ''}
                <Typography variant="tight-xxs" component="span">
                  {periodicityText}
                </Typography>
              </div>
            </>
          )}
          <div className={clsx(classes.tags, { [classes[align]]: align })}>
            <Tag className={classes.tag} size="tiny" color={hasFreeTrial ? 'teal' : 'grey'} disableRipple>
              Free trial
              <Icon icon={hasFreeTrial ? 'check' : 'times'} size="12" />
            </Tag>
            <Tag className={classes.tag} size="tiny" color={isFree ? 'teal' : 'grey'} disableRipple>
              Free version
              <Icon icon={isFree ? 'check' : 'times'} size="12" />
            </Tag>
          </div>
        </>
      )}
    </div>
  )
}

export default PricingDetails
